import { onboardingAuthApi } from 'onboarding/api/authApi'

class AuthService {
  public authByToken(token: string) {
    return onboardingAuthApi.authByToken(token)
  }
}

export const onboardingAuthService = new AuthService()
